// extracted by mini-css-extract-plugin
export default {"typingContainer":"TypingAnimation_typingContainer__NYaNl","dot":"TypingAnimation_dot__S9+D7","bounce":"TypingAnimation_bounce__m9BNe","fadeIn":"TypingAnimation_fadeIn__XkMBa"};